import React, { useEffect, useRef } from 'react';

import { isNonNegativeNumber, fixDecimals } from '../../../helpers/helpers';
import * as D3 from 'd3';

// added undefined cause TS issues
export const GaugeNFL = ({ maxVel, targetVel = undefined, compareFlag, popupFlag, curVel, previousVel }) => {
  const currentVel = 0;
  const data = D3.range(200).map(i => 1);
  const d3Container = useRef(null);
  const isFirstTime = useRef(true);
  useEffect(() => {
    const svg = D3.select(d3Container.current);
    svg
      .attr('height', '100%')
      .attr('width', '100%')
      .attr('viewBox', '0 0 500 300');
    svg.selectAll('*').remove();
    const group = svg.append('g');
    const selector = group.selectAll();
    group.attr('transform', 'translate(250,250)');

    const pie = D3.pie()
      .sort(null)
      .startAngle(-Math.PI / 2)
      .endAngle(Math.PI / 2);
    const arc = D3.arc()
      .innerRadius(180)
      .outerRadius(200);
    const scale = D3.scaleLinear([0, 0.5, 1], ['#4F9300', '#FB8C00', '#D6151C'])
      .interpolate(D3.interpolateHclLong);
    const dataFixed = pie(data);
    dataFixed.forEach(d => {
      d.startAngle -= 1 / 200;
      d.endAngle += 1 / 200;
    });

    selector.data(dataFixed)
      .enter()
      .append('path')
      .attr('fill', (d, i) => scale(i / (data.length - 1)))
      .attr('d', arc);
    const selectorBase = group
      .append('path')
      .attr('fill', '#ddd')
      .attr('d', D3.arc()
        .innerRadius(180)
        .outerRadius(200)
        .startAngle(-Math.PI / 2)
        .endAngle(Math.PI / 2 + 2 / 200)
      );
    const text = group.append('text')
      .text(0)
      .attr('x', 0)
      .attr('y', popupFlag ? -46 : -40)
      .attr('text-anchor', 'middle')
      .attr('alignment-baseline', 'baseline')
      .attr('font-size', popupFlag ? '80' : '100')
      .attr('fill', '#333D47')
      .attr('style', 'font-family: \'Roboto Condensed\'; font-weight: 900');
    const percentage = group.append('text')
      .text('15.6%')
      .attr('x', 0)
      .attr('y', popupFlag ? 0 : 50)
      .attr('text-anchor', 'middle')
      .attr('alignment-baseline', 'baseline')
      .attr('font-size', popupFlag ? '30' : '60')
      .attr('fill', '#42859E')
      .attr('style', 'font-family: \'Roboto Condensed\'; font-weight: 600');
    const rectangleCurVel = group
      .append('rect')
      .attr('x', -180 - 20)
      .attr('y', -5)
      .attr('height', 10)
      .attr('width', 20 + 20)
      .style('opacity', 0.9);
    const circleRecord = group
      .append('g');
    circleRecord
      .selectAll()
      .data([31, 22.5, 12])
      .enter()
      .append('circle')
      .attr('r', d => d)
      .attr('cx', -180 - 10)
      .attr('cy', 0)
      .attr('fill', (d, i) => i % 2 === 0 ? '#1d80aa' : 'white')
      .on('mouseover', () => tooltip.style('opacity', 1))
      .on('mouseleave', () => tooltip.style('opacity', 0));
    const tooltip = circleRecord
      .append('g')
      .style('opacity', 0);
    const yPosition = 0;
    const xPosition = -190;
    tooltip
      .append('rect')
      .attr('width', 104)
      .attr('height', 64)
      .attr('x', xPosition)
      .attr('y', yPosition)
      .attr('style', 'fill: #CBCBCB;')
      .attr('transform', 'translate(-52, -97)');
    tooltip
      .append('rect')
      .attr('width', 100)
      .attr('height', 60)
      .attr('x', xPosition)
      .attr('y', yPosition)
      .attr('style', 'fill: white;')
      .attr('transform', 'translate(-50, -95)');
    const tooltipText = tooltip
      .append('text')
      .text(fixDecimals(targetVel, 1))
      .attr('font-size', '40')
      .attr('fill', '#333D47')
      .attr('text-anchor', 'middle')
      .attr('x', xPosition)
      .attr('y', yPosition)
      .attr('style', 'font-family: \'Roboto Condensed\';font-weight: 900;text-align: center;')
      .attr('transform', 'translate(0, -50)');

    if (typeof (targetVel) !== 'undefined') {
      circleRecord.style('opacity', 1);
      tooltipText
        .text(fixDecimals(targetVel, 1));
      circleRecord
        .attr('transform', 'rotate(' + 180 * targetVel / maxVel + ')');
      tooltip
        .attr('transform', 'rotate(-' + 180 * targetVel / maxVel + ', -190, 0)');
    } else {
      circleRecord.style('opacity', 0);
    }
    const A = currentVel;
    const B = curVel;
    percentage.style('opacity', compareFlag ? 1 : 0);
    selectorBase
      .transition()
      .duration(isFirstTime.current ? 2000 : 0)
      .ease(D3.easeExpOut)
      .attrTween('d', () => t => {
        const startAngle = -Math.PI / 2 + Math.PI * (A + t * (B - A)) / maxVel;
        text.text(D3.format('.1f')(A + t * (B - A)));
        // let variation = ((A + t * (B - A)) < previousVel ? -(1 - (A + t * (B - A)) / previousVel): (A + t * (B - A)) / previousVel - 1) * 100;
        percentage
          .text(previousVel === -1 || !isNonNegativeNumber(previousVel) ? '-' : D3.format('.1f')(previousVel) + '%')
          .attr('fill', '#42859E');
        const arc = D3.arc()
          .innerRadius(179.5)
          .outerRadius(200.5)
          .startAngle(startAngle)
          .startAngle(startAngle)
          .endAngle(Math.PI / 2 + 2 / 200);
        if (((startAngle + Math.PI / 2) * 180 / Math.PI)) {
          rectangleCurVel
            .attr('transform', 'rotate(' + ((startAngle + Math.PI / 2) * 180 / Math.PI) + ')');
        }
        return arc();
      });
    if (typeof (targetVel) !== 'undefined') {
      circleRecord.style('opacity', 1);
      tooltipText
        .text(fixDecimals(targetVel, 1));
      circleRecord
        .attr('transform', 'rotate(' + 180 * targetVel / maxVel + ')');
      tooltip
        .attr('transform', 'rotate(-' + 180 * targetVel / maxVel + ', -190, 0)');
    } else {
      circleRecord.style('opacity', 0);
    }
    isFirstTime.current = false;
  }, [compareFlag, curVel, data, maxVel, popupFlag, previousVel, targetVel]);
  return (
    <svg
      className="d3-component"
      width={400}
      height={200}
      ref={d3Container}
    />
  );
};
